import { State } from 'ducks/reducers'
import { getTypedState } from 'ducks/hooks'
import { UserType } from './types'
import { concatSeparator, EMAIL_TYPE, getNameFromAbb, USER_TYPE } from 'helpers'

export const getUser = (state: State): UserType => state.user

export const getUserId = (): string => {
  const { user } = getTypedState()
  return user.id
}

export const getUserPrimaryEmail = (): string => {
  const { user } = getTypedState()
  const primaryEmail =
    user?.email?.find((e) => e?.emailType === EMAIL_TYPE.PRIMARY)?.email ||
    user?.email?.[0]?.email || ""
  return primaryEmail || 'No email registered'
}

export const getUserFullName = (): string => {
  const { user } = getTypedState()
  const { firstName, lastName } = user
  const fullName = concatSeparator(firstName, lastName, ' ')
  return fullName || 'No name registered'
}

export const getUserPhone = (): string => {
  const { user } = getTypedState()
  return user?.phone?.toString() || 'No phone'
}

export const getUserAddress = (): string => {
  const { user } = getTypedState()
  if (!user?.address) return 'No address'
  const { city, line_1: street1, line_2: unit, state, line1, line2 } = user.address
  const cityState = concatSeparator(city ?? '', state ?? '', ', ')
  const streetUnit = concatSeparator(street1 || line1 as string, unit || line2 as string, ', ')
  const address = concatSeparator(streetUnit ?? '', cityState ?? '', ', ')
  return address || 'No address'
}

export const getUserFullAddress = (): string => {
  const { user } = getTypedState()
  if (!user?.address) return 'No address registered'
  const {
    line_1: street1,
    line_2: street2,
    line1,
    line2,
    city,
    state,
    zipCode,
  } = user.address
  // if (!street1 || !street2) return 'No address registered'
  let fullAddress = concatSeparator(street1 || line1 as string, street2 || line2 as string, ' ')
  fullAddress = concatSeparator(fullAddress, city, ', ')
  fullAddress = concatSeparator(fullAddress, getNameFromAbb(state), ', ')
  fullAddress = concatSeparator(fullAddress, zipCode, ', ')

  return fullAddress || 'No address registered'
}

export const getUserIsHomeowner = (): boolean => {
  const { user } = getTypedState()
  const clientType = user?.clientType
  if (!clientType) return false
  return [USER_TYPE.HOMEOWNER, USER_TYPE.HOME_BUYER, USER_TYPE.HOME_SELLER, USER_TYPE.INSTITUTIONAL].includes(clientType)
}
